import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdArrowDropDown, MdArrowDropUp, MdDelete, MdFileDownload, MdReply, MdUploadFile } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner, FormCheck } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import ModalQuestao from '../CategoriasQuestoes/ModalQuestao';



import { FormControlLabel, Radio, TextField } from '@material-ui/core';
import './label.css';
import { DatePicker, TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import 'moment/locale/pt-br';
import { alpha } from '@material-ui/core/styles';
import { BsFile, BsFillEyeFill } from 'react-icons/bs';
import DragDropTable from './DragDropTable';

import ModalPalavraChave from './ModalPalavraChave';
import ModalQuestoesDocx from './ModalQuestoesDocx';
import { RadioGroup } from '@mui/material';
import BlockSelect from '../BlocosProcesso/BlockSelect';
import TableEmptyState from '../ReusableComponents/TableEmptyState';

class EditarProva extends Component {static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: true,
      roles: [],
      name: '',
      enunciado: '',
      msgErroTextoApoio: '',
      loading_save: false,
      msgErro: '',
      loading_image: false,
      inicio: moment(),
      processo: { name: '', id: '' },
      arquivos: [],
      texto: '',
      titulo: '',
      texto_value: '',
      questao_enunciado: '',
      show_autocomplete_questao: false,
      loading_search_questao: false,
      questoes: [],
      questoes_selecionadas: {},
      categorias: [],
      categoria: { id: '' },
      random_layouts_max: false,
      number_exams: 1,
      time: 0,
      time_per_question: 3,
      showModal: false,
      showModalQuestoesDocx: false,
      questaoSelect: null,
      loading_get_all: false,
      questoes_array: [],
      tipos_prova: [
      {
        id: 'multipla_escolha',
        nameKey: "legacy_prova_objetiva"
      },
      {
        id: 'dissertativa',
        name: 'Prova dissertativa'
      }],

      type: 'multipla_escolha',
      showModalPalavraChave: false,
      aleatorizar_questoes: false,
      aleatorizar_alternativas: false,
      one_question_per_page: false,
      select_from_group: false,
      number_select_questions: 0,
      random_per_category: false,
      categorias_selecionadas: [],
      exibicao: 'folha_respostas',
      mirror: false,
      show_result_start_at: '',
      show_result_end_at: '',
      allow_download_answer_sheet: true,
      allow_download_accuracy_sheet: false,
      allow_download_mirror: false,
      block_return_after_pause: false,
      block_return: false,
      show_answer_map: true,
      auto_advance_on_answer: false,
      statusFilter: 'all',
      block_id: ''

    };


  }

  get_processo(id) {

    if (this.state.loading_screen == false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_prova/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });

          //   setTimeout(()=>{
          //     this.get_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);
          let questoes_selecionadas = {};
          for (let i = 0; i < resp.prova.questoes.length; i++) {
            questoes_selecionadas['q_' + resp.prova.questoes[i].id.toString()] = resp.prova.questoes[i];
          }
          console.log(questoes_selecionadas);
          console.log(Object.values(questoes_selecionadas));

          this.setState({
            loading_screen: false, processo: resp.prova.processo,
            categorias: resp.categorias,
            name: resp.prova.name,
            questoes_selecionadas,
            type: resp.prova.type,
            block_return_after_pause: resp.prova.block_return_after_pause,
            random_layouts_max: resp.prova.random_layouts_max,
            number_exams: resp.prova.number_exams ? resp.prova.number_exams : 1,
            aleatorizar_questoes: resp.prova.random_questions,
            aleatorizar_alternativas: resp.prova.random_alternatives,
            time_per_question: resp.prova.time,
            block_return: resp.prova.block_return,
            show_answer_map: resp.prova.show_answer_map !== false && resp.prova.show_answer_map !== 0 && resp.prova.show_answer_map !== '0',
            auto_advance_on_answer: resp.prova.auto_advance_on_answer == true,
            block_id: resp.prova.block ? resp.prova.block.id : '',
            // one_question_per_page: ,
            one_question_per_page: resp.prova.processo.need_pause == true || resp.prova.processo.exam_per_time == true ? true : resp.prova.one_question_per_page,
            select_from_group: resp.prova.select_from_group,
            number_select_questions: resp.prova.number_select_questions == null ? 0 : resp.prova.number_select_questions,
            random_per_category: resp.prova.random_per_category,
            categorias_selecionadas: resp.prova.categorias_selecionadas.filter((item2, id2) => {
              if (item2.categoria != null) {
                return true;
              } else
              {
                return false;
              }
            }).map((item, id) => {
              item.categoria.order = item.order;
              item.categoria.number = item.number;

              return item.categoria;
            }),
            exibicao: resp.prova.folha_resposta == true && resp.prova.show_acertos == true ? 'folha_relacao' : resp.prova.folha_resposta == true ? 'folha_respostas' : resp.prova.show_acertos == true ? 'relacao_acerto_erros' : 'none',
            mirror: resp.prova.mirror == true,
            show_result_start_at: resp.prova.show_result_start_at ? moment(resp.prova.show_result_start_at).format('YYYY-MM-DDTHH:mm') : '',
            show_result_end_at: resp.prova.show_result_end_at ? moment(resp.prova.show_result_end_at).format('YYYY-MM-DDTHH:mm') : '',
            allow_download_answer_sheet: resp.prova.allow_download_answer_sheet == true,
            allow_download_accuracy_sheet: resp.prova.allow_download_accuracy_sheet == true,
            allow_download_mirror: resp.prova.allow_download_mirror == true
          });
          // if (resp.processo != null) {

        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }



  salvar(e) {
    e.preventDefault();
    this.setState({ loading_save: true, msgErro: '' });


    let data = {};
    data.name = this.state.name;
    if (Object.values(this.state.questoes_selecionadas).length == 0) {
      this.setState({ loading_save: false, msgErro: 'A prova deve ter pelo menos uma questão' });
      return;
    }
    let questoes = this.state.questoes_array.map((item, id) => item.id);
    data.questoes = questoes;
    data.processo_id = this.state.processo.id;
    data.type = this.state.type;
    data.aleatorizar_questoes = this.state.aleatorizar_questoes;
    data.aleatorizar_alternativas = this.state.aleatorizar_alternativas;
    data.one_question_per_page = this.state.processo.need_pause == true || this.state.processo.exam_per_time == true ? true : this.state.one_question_per_page;
    data.select_from_group = this.state.select_from_group;
    data.block_return = this.state.block_return;
    data.show_answer_map = this.state.type != 'dissertativa' ? this.state.show_answer_map : true;
    data.auto_advance_on_answer = this.state.type != 'dissertativa' && this.state.one_question_per_page == true && this.state.block_return == true ? this.state.auto_advance_on_answer : false;
    data.number_select_questions = this.state.number_select_questions;
    data.block_return_after_pause = this.state.block_return_after_pause;
    if (this.state.processo.has_blocks === true || this.state.processo.has_blocks === 1 || this.state.processo.has_blocks === '1') {
      data.block_id = this.state.block_id || null;
    }

    data.random_per_category = this.state.random_per_category;
    data.random_layouts_max = this.state.random_layouts_max;
    data.number_exams = this.state.random_layouts_max == true ? this.state.number_exams : null;
    data.time = this.state.time_per_question * Object.values(this.state.questoes_selecionadas).map((item, id) => {
      if (item.type_questao == 'conjunto') {
        return item.questoes.length;
      } else
      {
        return 1;
      }
    }).reduce((a, b) => a + b, 0) ?? 0;

    data.time_per_question = this.state.time_per_question;
    data.categorias_selecionadas = this.state.categorias_selecionadas.sort((a, b) => a.order - b.order).map((item, id) => item.id);
    data.prova_id = this.props.match.params.id;
    data.categorias_number = this.state.categorias_selecionadas.sort((a, b) => a.order - b.order).map((item, id) => item.number);
    data.exibicao = this.state.exibicao;
    data.mirror = this.state.type != 'dissertativa' ? this.state.mirror : false;
    data.show_result_start_at = this.state.show_result_start_at || null;
    data.show_result_end_at = this.state.show_result_end_at || null;
    data.allow_download_answer_sheet = this.state.exibicao == 'folha_respostas' || this.state.exibicao == 'folha_relacao' ? this.state.allow_download_answer_sheet : false;
    data.allow_download_accuracy_sheet = this.state.exibicao == 'relacao_acerto_erros' || this.state.exibicao == 'folha_relacao' ? this.state.allow_download_accuracy_sheet : false;
    data.allow_download_mirror = this.state.mirror == true ? this.state.allow_download_mirror : false;

    // let questoes=Object.values(this.state.questoes_selecionadas).sort((a, b) => {
    //     if (a.created_at > b.created_at) {
    //         return 1;
    //       }
    //       if (a.created_at < b.created_at) {
    //         return -1;
    //       }
    //       // a must be equal to b
    //       return 0;
    // }).sort((a, b) => {
    //     if (a.categoria.created_at > b.categoria.created_at) {
    //         return 1;
    //       }
    //       if (a.categoria.created_at < b.categoria.created_at) {
    //         return -1;
    //       }
    //       // a must be equal to b
    //       return 0;
    // }).map((item,id)=>item.id);


    fetch(`${URL}api/faculdade/update_prova`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',

        'Authorization': `Bearer ${this.props.token}`
      },
      body: JSON.stringify(data)
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          window.scrollTo(500, 0);

          this.setState({ loading_save: false, msgErro: erro });
        } else
        {

          this.setState({ loading_save: false, redirect: true });

        }




      } catch (err) {
        console.log(err);
        this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor' });

      }

    }).
    catch((err) => {
      console.log(err);
      this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?' });
    });
  }


  get_questoes_categoria(categoria_id) {
    if (this.state.loading_get_all == false) {
      this.setState({ loading_get_all: true });
    }
    fetch(`${URL}api/faculdade/get_questoes_categoria/${categoria_id}?type=${this.state.type}&status=${this.state.statusFilter}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          // this.setState({ redirect: true });
          this.setState({ loading_get_all: false });

          //   setTimeout(()=>{
          //     this.get_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);
          let questoes = { ...this.state.questoes_selecionadas };
          for (let i = 0; i < resp.questoes.length; i++) {
            if (questoes['q_' + resp.questoes[i].id] == undefined) {
              questoes['q_' + resp.questoes[i].id] = resp.questoes[i];
            }
          }



          this.setState({ loading_get_all: false, questao_enunciado: '', show_autocomplete_questao: false, questoes_selecionadas: questoes });
          // if (resp.processo != null) {


        }




      } catch (err) {
        this.setState({ loading_get_all: false });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ loading_get_all: false });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }


  componentDidMount() {
    this.get_processo(this.props.match.params.id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (Object.values(prevState.questoes_selecionadas).length != Object.values(this.state.questoes_selecionadas).length) {
      this.parseQuestoesDragDrop();
    }
  }

  parseQuestoesDragDrop() {
    let questoes = [...this.state.questoes_array];
    let ids = questoes.map((item, id) => item.id);
    let ids_exists = [];

    let categorias_selecionadas = [...this.state.categorias_selecionadas];
    let ids_categoria = categorias_selecionadas.map((item, id) => item.id);
    let ids_exists_categoria = [];


    for (let i = 0; i < Object.values(this.state.questoes_selecionadas).length; i++) {

      let item = Object.values(this.state.questoes_selecionadas)[i];
      ids_exists.push(item.id);
      ids_exists_categoria.push(item.categoria.id);

      if (!ids.includes(item.id)) {
        questoes.push({
          numero: i + 1,
          id: item.id,
          enunciado: <p className='text_overflow'>{item.text_questao}</p>,
          categoria: item.categoria.name,
          tipo_questao: <p style={{ whiteSpace: 'pre' }}>{item.type_questao == 'conjunto' ? 'Conjunto de questões\n' + item.questoes.length + (item.questoes.length == 1 ? ' questão' : ' questões') :
            item.type_questao == 'simples' ? this.context.t("legacy_questao_unica") : 'Questão dissertativa'}</p>,
          acoes: i
        });
      }
      if (!ids_categoria.includes(item.categoria.id)) {
        categorias_selecionadas.push({ ...item.categoria, order: categorias_selecionadas.length, number: 1 });
        ids_categoria.push(item.categoria.id);
      }
    }
    questoes = questoes.filter((item, id) => {
      if (ids_exists.includes(item.id)) {
        return true;
      }
      return false;
    });

    categorias_selecionadas = categorias_selecionadas.filter((item, id) => {
      if (ids_exists_categoria.includes(item.id)) {
        return true;
      }
      return false;
    });

    this.setState({ questoes_array: questoes, categorias_selecionadas });
  }

  get_questao_search(search, categoria_id) {
    if (this.state.loading_search_questao == false) {
      this.setState({ loading_search_questao: true });
    }
    fetch(`${URL}api/faculdade/get_questoes_search?page=1&search=${search}&categoria_id=${categoria_id}&type=${this.state.type}&status=${this.state.statusFilter}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          // this.setState({ redirect: true });
          this.setState({ loading_search_questao: false });

          //   setTimeout(()=>{
          //     this.get_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);
          this.setState({ loading_search_questao: false, questoes: resp.questoes });
          // if (resp.processo != null) {


        }




      } catch (err) {
        this.setState({ loading_search_questao: false });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ loading_search_questao: false });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }


  select_questao(item) {
    let questoes = { ...this.state.questoes_selecionadas };
    if (questoes['q_' + item.id] == undefined) {
      questoes['q_' + item.id] = item;
    }
    this.setState({ questao_enunciado: '', show_autocomplete_questao: false, questoes_selecionadas: questoes });
  }

  add_questoes_docx(questoes_importadas) {
    let questoes_validas = questoes_importadas.filter((questao) => {
      if (this.state.type == 'dissertativa') {
        return questao.type_questao == 'dissertativa';
      }

      return questao.type_questao == 'simples' || questao.type_questao == 'conjunto';
    });

    if (questoes_validas.length == 0 && questoes_importadas.length > 0) {
      this.setState({
        msgErro: this.state.type == 'dissertativa' ?
        this.context.t('docx_error_only_objective_for_discursive_exam') :
        this.context.t('docx_error_only_discursive_for_objective_exam'),
        showModalQuestoesDocx: false
      });
      return;
    }

    let questoes = { ...this.state.questoes_selecionadas };
    let categorias = [...this.state.categorias];
    let categorias_ids = categorias.map((item) => item.id);

    for (let i = 0; i < questoes_validas.length; i++) {
      let questao = questoes_validas[i];
      if (questoes['q_' + questao.id] == undefined) {
        questoes['q_' + questao.id] = questao;
      }

      if (questao.categoria != null && !categorias_ids.includes(questao.categoria.id)) {
        categorias.push(questao.categoria);
        categorias_ids.push(questao.categoria.id);
      }
    }

    categorias.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    let msgErro = '';
    if (questoes_validas.length < questoes_importadas.length) {
      msgErro = this.state.type == 'dissertativa' ?
      this.context.t('docx_warning_objective_ignored_discursive_exam') :
      this.context.t('docx_warning_discursive_ignored_objective_exam');
    }

    this.setState({ questoes_selecionadas: questoes, categorias, showModalQuestoesDocx: false, msgErro });
  }


  change_tipo(event) {
    this.setState({ tipo: event.target.value });
  }


  render() {
    return (
      <div className="row">
                {this.state.redirect == true && <Redirect to={`/processos/show/${this.state.processo.id}?tab=1`} />}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card" style={{ overflow: 'visible' }}>

                            <div hidden id="text_enunciado">

                            </div>
                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{this.context.t("ui_editar_prova_097be7e1")}</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>Edite uma prova {this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("legacy_do_processo") : this.context.t("label_of_vacancy_position")} {this.state.processo.name}</p>
                            <br />
                            <ModalQuestao showModal={this.state.showModal} setShowModal={(e) => this.setState({ showModal: e })} questao={this.state.questaoSelect} />
                            <ModalPalavraChave statusFilter={this.state.statusFilter} saveQuestoes={(questoes_selecionadas) => {
                let questoes = { ...this.state.questoes_selecionadas };
                for (let i = 0; i < Object.keys(questoes_selecionadas).length; i++) {
                  if (questoes['q_' + Object.values(questoes_selecionadas)[i].id] == undefined) {
                    questoes['q_' + Object.values(questoes_selecionadas)[i].id] = Object.values(questoes_selecionadas)[i];
                  }
                }
                this.setState({ questoes_selecionadas: questoes, showModalPalavraChave: false });
              }} type={this.state.type} showModal={this.state.showModalPalavraChave} setShowModal={(e) => this.setState({ showModalPalavraChave: e })} categoria={this.state.categoria} />
                            <ModalQuestoesDocx
                              showModal={this.state.showModalQuestoesDocx}
                              setShowModal={(e) => this.setState({ showModalQuestoesDocx: e })}
                              saveQuestoes={(questoes) => this.add_questoes_docx(questoes)}
                            />

                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>
                                {this.state.msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                                    <div className="badge badge-danger error-message-badge error-message-badge-dismissible w-100" role="alert">
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ msgErro: '' })}></button>


                                        <p style={{ marginBottom: 0 }}>{this.state.msgErro}</p>

                                    </div>
                                    <br />

                                </div>}
                                <Form onSubmit={(e) => this.salvar(e)} style={{ position: "relative" }}>
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>Tipo de prova <Attention /></Form.Label>

                                            <select disabled={this.state.loading_get_all} className="form-select " onChange={(e) => {

                        this.setState({ categoria: { id: '' }, exibicao: e.target.value == 'dissertativa' ? 'none' : this.state.exibicao, one_question_per_page: e.target.value == 'dissertativa' ? true : this.state.one_question_per_page, auto_advance_on_answer: e.target.value == 'dissertativa' ? false : this.state.auto_advance_on_answer, mirror: e.target.value == 'dissertativa' ? false : this.state.mirror, allow_download_mirror: e.target.value == 'dissertativa' ? false : this.state.allow_download_mirror, type: e.target.value, questao_enunciado: '', questoes: [], questoes_selecionadas: {}, questoes_array: [] });
                      }} value={this.state.type}>
                                                {this.state.tipos_prova && this.state.tipos_prova.length != 0 && this.state.tipos_prova.map((value, index) =>
                        <option
                          key={index}
                          value={value["id"]}>
                          {value["nameKey"] ? this.context.t(value["nameKey"]) : value["name"]}</option>
                        )}
                                            </select>

                                        </div>

                                    </InputGroup>
                                    <BlockSelect
                      processo={this.state.processo}
                      token={this.props.token}
                      value={this.state.block_id}
                      onChange={(block_id) => this.setState({ block_id })} />
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("label_name")} `}<Attention /></Form.Label>
                                            <Input
                        placeholder={this.context.t("legacy_nome_da_prova")}
                        value={this.state.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                                        </div>
                                    </InputGroup>
                                    {(this.props.user?.empresa?.plan?.layout_children == true || this.props.user?.empresa?.online_proccess == true && this.state.processo.online == true) && <>

                                        <hr />
                                        <h5 style={{ fontWeight: 'bold' }}>{this.context.t("ui_configuracoes_adicionais_0d9c9733")}</h5>
                                        <br />
                                    </>}

                                    {this.props.user?.empresa?.plan?.layout_children == true && <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("ui_ordem_das_questoes_d3f085f2")}<Attention /></Form.Label>

                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={this.state.aleatorizar_questoes}
                        onChange={(e) => {
                          console.log(e.target.value);
                          this.setState({ aleatorizar_questoes: e.target.value });
                        }}>

                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ aleatorizar_questoes: false, random_layouts_max: this.state.aleatorizar_alternativas == true ? this.state.random_layouts_max : false });
                        }} control={<Radio checked={this.state.aleatorizar_questoes == false} value={false} />} style={{ color: 'black' }} label={'Questões na ordem de cadastro'} />
                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ aleatorizar_questoes: true, random_layouts_max: this.props.user?.empresa?.online_proccess == true && this.state.processo.online == true ? this.state.random_layouts_max : true });

                        }} control={<Radio checked={this.state.aleatorizar_questoes == true} value={true} />} style={{ color: 'black' }} label={'Questões em ordem aleatória'} />
                                            </RadioGroup>

                                        </div>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                        </div>

                                    </InputGroup>}
                                    {this.state.aleatorizar_questoes == true && <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("ui_selecao_das_questoes_c85b2f2d")}<Attention /></Form.Label>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group1"
                        value={this.state.select_from_group}
                        onChange={(e) => {
                          console.log(e.target.value);
                          this.setState({ select_from_group: e.target.value });
                        }}>


                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ select_from_group: false });

                        }} control={<Radio checked={this.state.select_from_group == false} value={false} />} style={{ color: 'black' }} label={'Usar todas questões selecionadas'} />
                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ select_from_group: true });
                        }} control={<Radio checked={this.state.select_from_group == true} value={true} />} style={{ color: 'black' }} label={'Selecionar questões aleatórias para a prova de cada candidato'} />
                                                {/* <Form.Label>Número de questões por prova <Attention /></Form.Label> */}

                                            </RadioGroup>
                                        </div>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("ui_forma_de_aleatorizacao_499ad86d")}<Attention /></Form.Label>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group0"
                        value={this.state.random_per_category}
                        onChange={(e) => {
                          console.log(e.target.value);
                          this.setState({ random_per_category: e.target.value });
                        }}>


                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ random_per_category: false });

                        }} control={<Radio checked={this.state.random_per_category == false} value={false} />} style={{ color: 'black' }} label={'Seguindo a ordem das disciplinas'} />
                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ random_per_category: true });
                        }} control={<Radio checked={this.state.random_per_category == true} value={true} />} style={{ color: 'black' }} label={'Questões de forma aleatória independente da disciplina'} />
                                            </RadioGroup>
                                            {this.state.random_per_category == false && <>
                                                <Form.Label className='mt-1'>Ordem das disciplinas: </Form.Label>
                                                {this.state.categorias_selecionadas.sort((a, b) => a.order - b.order).map((item, id) =>
                        <div key={id} className="d-flex justify-content-between mt-2">
                                                        <p>{item.name}</p>
                                                        <div style={{ marginRight: 15, display: 'flex' }}>
                                                            {this.state.select_from_group == true && <Input
                              onWheel={(e) => e.target.blur()}

                              placeholder={this.context.t("ui_numero_de_questoes_que_devem_ser_selecionadas_c940b4a7")}
                              value={item.number}
                              type="number"
                              min={1}
                              onChange={(e) => {
                                let categorias_selecionadas = this.state.categorias_selecionadas.map((item2, id2) => {
                                  if (item2.id == item.id) {
                                    item2.number = e.target.value;
                                  }
                                  return item2;
                                });
                                this.setState({ categorias_selecionadas }, () => {
                                  console.log(categorias_selecionadas);
                                });
                              }}
                              required
                              style={{ maxWidth: 80 }}
                              // max={Object.values(this.state.questoes_selecionadas).filter((item2,id2)=>{
                              //     if(item2.categoria_id==item.id){
                              //         return true;
                              //     }
                              //     return false;
                              // }).map((item2, id2) => {
                              //     if (item2.type_questao == 'conjunto') {
                              //         return item2.questoes.length;
                              //     }
                              //     else {
                              //         return 1;
                              //     }
                              // }).reduce((a, b) => a + b, 0)}

                              // title="Coloque o nome completo do usuário"
                            />}
                                                            <MdArrowDropUp style={{ cursor: 'pointer', color: id == 0 ? 'grey' : 'black' }} className="click_input" onClick={() => {
                              // if(item.order)
                              let first = true;
                              let categorias_selecionadas = this.state.categorias_selecionadas.map((item2, id2) => {
                                if (id2 + 1 == id && first == true) {
                                  let order = item.order;
                                  console.log(order, item2.order);

                                  item.order = item2.order;
                                  item2.order = order;
                                  first = false;
                                  console.log('order changed');

                                }
                                return item2;
                              });
                              console.log(categorias_selecionadas);

                              categorias_selecionadas = categorias_selecionadas.map((item2, id2) => {
                                if (item2.id == item.id) {
                                  return item;
                                }
                                return item2;
                              });
                              console.log(categorias_selecionadas);

                              this.setState({ categorias_selecionadas });
                            }} size={30} />
                                                            <MdArrowDropDown className="click_input" style={{ cursor: 'pointer', color: id == this.state.categorias_selecionadas.length - 1 ? 'grey' : 'black' }} onClick={() => {
                              let first = true;
                              let categorias_selecionadas = this.state.categorias_selecionadas.map((item2, id2) => {
                                if (id2 - 1 == id && first == true) {
                                  let order = item.order;
                                  item.order = item2.order;
                                  item2.order = order;
                                  first = false;
                                }
                                return item2;
                              });
                              categorias_selecionadas = categorias_selecionadas.map((item2, id2) => {
                                if (item2.id == item.id) {
                                  return item;
                                }
                                return item2;
                              });
                              console.log(categorias_selecionadas);
                              this.setState({ categorias_selecionadas });
                            }} size={30} />

                                                        </div>
                                                    </div>
                        )}
                                                {this.state.categorias_selecionadas.length == 0 &&
                        <div>
                                                        <TableEmptyState title={this.context.t("legacy_nenhuma_questao_selecionada")} icon="❓" />
                                                    </div>
                        }
                                            </>}

                                            {this.state.select_from_group == true && this.state.random_per_category == true && <>

                                                <Form.Label className='mt-1'>{this.context.t("ui_numero_de_questoes_que_devem_ser_selecionadas_def12a81")}</Form.Label>

                                                <Input
                          onWheel={(e) => e.target.blur()}

                          placeholder={this.context.t("ui_numero_de_questoes_que_devem_ser_selecionadas_c940b4a7")}
                          value={this.state.number_select_questions}
                          type="number"
                          onChange={(e) => this.setState({ number_select_questions: e.target.value })}
                          required
                          min={1}
                          max={Object.values(this.state.questoes_selecionadas).map((item, id) => {
                            if (item.type_questao == 'conjunto') {
                              return item.questoes.length;
                            } else
                            {
                              return 1;
                            }
                          }).reduce((a, b) => a + b, 0)}
                          // title="Coloque o nome completo do usuário"
                        /></>}


                                        </div>



                                    </InputGroup>}
                                    <InputGroup>

                                        {this.props.user?.empresa?.plan?.layout_children == true && this.state.type != 'dissertativa' && <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("label_alternative_order")} <Attention /></Form.Label>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group2"
                        value={this.state.aleatorizar_alternativas}
                        onChange={(e) => {
                          console.log(e.target.value);
                          this.setState({ aleatorizar_alternativas: e.target.value });
                        }}>

                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ aleatorizar_alternativas: false, random_layouts_max: this.state.aleatorizar_questoes == true ? this.state.random_layouts_max : false });
                        }} control={<Radio checked={this.state.aleatorizar_alternativas == false} value={false} />} style={{ color: 'black' }} label={this.context.t("label_registered_order_alternatives")} />
                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ aleatorizar_alternativas: true, random_layouts_max: this.props.user?.empresa?.online_proccess == true && this.state.processo.online == true ? this.state.random_layouts_max : true });

                        }} control={<Radio checked={this.state.aleatorizar_alternativas == true} value={true} />} style={{ color: 'black' }} label={this.context.t("label_random_order_alternatives")} />
                                            </RadioGroup>
                                        </div>}
                                        {this.props.user?.empresa?.online_proccess == true && this.state.processo.online == true && <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("ui_exibicao_das_questoes_8463a65b")}<Attention /></Form.Label>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group3"
                        value={this.state.one_question_per_page}
                        onChange={(e) => {
                          console.log(e.target.value);
                          // if (this.state.type == 'dissertativa') {
                          //     return;
                          // }
                          // this.setState({ one_question_per_page: e.target.value });
                        }}>


                                                <FormControlLabel disabled={this.state.type == 'dissertativa' || this.state.processo.exam_per_time == true || this.state.processo.need_pause == true} onClick={(e) => {
                          if (this.state.type == 'dissertativa' || this.state.processo.exam_per_time == true || this.state.processo.need_pause == true) {
                            return;
                          }
                          console.log(e.target.value);
                          this.setState({ one_question_per_page: false, block_return: false, auto_advance_on_answer: false });

                        }} control={<Radio checked={this.state.one_question_per_page == false} value={false} />} style={{ color: 'black' }} label={'Todas questões exibidas de uma vez, em lista'} />
                                                <FormControlLabel disabled={this.state.type == 'dissertativa' || this.state.processo.exam_per_time == true || this.state.processo.need_pause == true} onClick={(e) => {
                          if (this.state.type == 'dissertativa' || this.state.processo.exam_per_time == true || this.state.processo.need_pause == true) {
                            return;
                          }
                          console.log(e.target.value);
                          this.setState({ one_question_per_page: true });
                        }} control={<Radio checked={this.state.one_question_per_page == true} value={true} />} style={{ color: 'black' }} label={'Uma questão exibida por vez'} />
                                            </RadioGroup>
                                        </div>}
                                    </InputGroup>


                                    <InputGroup>

                                        {this.props.user?.empresa?.plan?.layout_children == true && <div className="flex fdcolumn flex1 margin-bottom me-3">

                                            <Form.Label>{this.context.t("ui_definir_um_numero_maximo_de_provas_aleatorias_gera_78fd6056")}<Attention /></Form.Label>

                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={this.state.random_layouts_max}
                        onChange={(e) => {
                          console.log(e.target.value);
                          if (this.state.aleatorizar_questoes == false && this.state.aleatorizar_alternativas == false || this.props.user?.empresa?.online_proccess == false || this.state.processo.online == false) {
                            return;
                          }
                          this.setState({ random_layouts_max: e.target.value });
                        }}>
                                                <FormControlLabel disabled={this.state.aleatorizar_questoes == false && this.state.aleatorizar_alternativas == false || this.props.user?.empresa?.online_proccess == false || this.state.processo.online == false} onClick={(e) => {
                          console.log(e.target.value);
                          if (this.state.aleatorizar_questoes == false && this.state.aleatorizar_alternativas == false || this.props.user?.empresa?.online_proccess == false || this.state.processo.online == false) {
                            return;
                          }
                          this.setState({ random_layouts_max: true });

                        }} control={<Radio checked={this.state.random_layouts_max == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />

                                                <FormControlLabel disabled={this.state.aleatorizar_questoes == false && this.state.aleatorizar_alternativas == false || this.props.user?.empresa?.online_proccess == false || this.state.processo.online == false} onClick={(e) => {
                          console.log(e.target.value);
                          if (this.state.aleatorizar_questoes == false && this.state.aleatorizar_alternativas == false || this.props.user?.empresa?.online_proccess == false || this.state.processo.online == false) {
                            return;
                          }
                          this.setState({ random_layouts_max: false });
                        }} control={<Radio checked={this.state.random_layouts_max == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                            </RadioGroup>

                                            {this.state.random_layouts_max == true && <>

                                                <Form.Label className='mt-1'>{this.context.t("ui_numero_de_provas_geradas_5c4213f8")}</Form.Label>

                                                <Input
                          onWheel={(e) => e.target.blur()}
                          placeholder={this.context.t("ui_numero_de_provas_que_vao_ser_geradas_ebe3dc3e")}
                          value={this.state.number_exams}
                          type="number"
                          onChange={(e) => this.setState({ number_exams: e.target.value })}
                          required
                          min={1}
                          // title="Coloque o nome completo do usuário"
                        /></>}

                                        </div>}
                                        {this.props.user?.empresa?.online_proccess == true && this.state.processo.online == true && <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("ui_o_candidato_podera_retornar_para_a_questao_anterio_9d388b4d")}<Attention /></Form.Label>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group3"
                        value={this.state.block_return}
                        onChange={(e) => {
                          console.log(e.target.value);
                          // if (this.state.type == 'dissertativa') {
                          //     return;
                          // }
                          // this.setState({ one_question_per_page: e.target.value });
                        }}>


                                                <FormControlLabel disabled={this.state.one_question_per_page == false || this.state.processo.exam_per_time == true} onClick={(e) => {
                          if (this.state.one_question_per_page == false || this.state.processo.exam_per_time == true) {
                            return;
                          }
                          console.log(e.target.value);
                          this.setState({ block_return: false, auto_advance_on_answer: false });

                        }} control={<Radio checked={this.state.block_return == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                <FormControlLabel disabled={this.state.one_question_per_page == false || this.state.processo.exam_per_time == true} onClick={(e) => {
                          if (this.state.one_question_per_page == false || this.state.processo.exam_per_time == true) {
                            return;
                          }
                          console.log(e.target.value);
                          this.setState({ block_return: true });
                        }} control={<Radio checked={this.state.block_return == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                            </RadioGroup>
                                        </div>}

                                    </InputGroup>

                                    {this.props.user?.empresa?.online_proccess == true && this.state.processo.online == true && this.state.type != 'dissertativa' && this.state.one_question_per_page == true && this.state.block_return == true && this.state.processo.exam_per_time != true && <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("form_auto_advance_on_answer_question")}<Attention /></Form.Label>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group-auto-advance"
                        value={this.state.auto_advance_on_answer}
                        onChange={(e) => {
                          console.log(e.target.value);
                        }}>
                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ auto_advance_on_answer: true });
                        }} control={<Radio checked={this.state.auto_advance_on_answer == true} value={true} />} style={{ color: 'black' }} label={this.context.t("form_auto_advance_on_answer_yes")} />
                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ auto_advance_on_answer: false });
                        }} control={<Radio checked={this.state.auto_advance_on_answer == false} value={false} />} style={{ color: 'black' }} label={this.context.t("form_auto_advance_on_answer_no")} />
                                            </RadioGroup>
                                        </div>
                                    </InputGroup>}

                                    {this.state.type != 'dissertativa' && <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("form_show_answer_map_question")}<Attention /></Form.Label>
                                            <small>{this.context.t("description_show_answer_map")}</small>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group-show-answer-map"
                        value={this.state.show_answer_map}>
                                                <FormControlLabel onClick={() => {
                          this.setState({ show_answer_map: true });
                        }} control={<Radio checked={this.state.show_answer_map == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                <FormControlLabel onClick={() => {
                          this.setState({ show_answer_map: false });
                        }} control={<Radio checked={this.state.show_answer_map == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                            </RadioGroup>
                                        </div>
                                    </InputGroup>}

                                    {this.props.user?.empresa?.online_proccess == true && this.state.processo.online == true && <InputGroup>
                                        {this.state.type != 'dissertativa' && this.state.processo.need_pause == true && <div className="flex fdcolumn flex1 margin-bottom me-3">
                                            <Form.Label>{this.context.t("ui_bloquear_de_alterar_respostas_de_questoes_ja_vista_cb647283")}<Attention /></Form.Label>

                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={this.state.block_return_after_pause}
                        onChange={(e) => {
                          console.log(e.target.value);
                          if (this.state.type == 'dissertativa') {
                            return;
                          }
                          this.setState({ block_return_after_pause: e.target.value });
                        }}>

                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          if (this.state.type == 'dissertativa') {
                            return;
                          }
                          this.setState({ block_return_after_pause: true });
                        }} control={<Radio checked={this.state.block_return_after_pause == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          if (this.state.type == 'dissertativa') {
                            return;
                          }
                          this.setState({ block_return_after_pause: false });

                        }} control={<Radio checked={this.state.block_return_after_pause == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                            </RadioGroup>

                                        </div>}
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("form_finished_result_visibility")} <Attention /></Form.Label>

                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={this.state.mirror == true ? (this.state.exibicao == 'relacao_acerto_erros' ? 'mirror_candidate' : 'mirror_correct') : this.state.exibicao}
                        onChange={(e) => {
                          console.log(e.target.value);
                          if (this.state.type == 'dissertativa') {
                            return;
                          }
                          if (e.target.value == 'mirror_correct') {
                            this.setState({ exibicao: 'none', mirror: true, allow_download_answer_sheet: false, allow_download_accuracy_sheet: false });
                          } else if (e.target.value == 'mirror_candidate') {
                            this.setState({ exibicao: 'relacao_acerto_erros', mirror: true, allow_download_answer_sheet: false, allow_download_accuracy_sheet: false });
                          } else if (e.target.value == 'none') {
                            this.setState({ exibicao: 'none', mirror: false, allow_download_answer_sheet: false, allow_download_accuracy_sheet: false, allow_download_mirror: false });
                          } else {
                            this.setState({ exibicao: e.target.value, mirror: false, allow_download_mirror: false });
                          }
                        }}>

                                                <FormControlLabel disabled={this.state.type == 'dissertativa'} onClick={(e) => {
                          console.log(e.target.value);
                          if (this.state.type == 'dissertativa') {
                            return;
                          }
                          this.setState({ exibicao: 'folha_respostas', mirror: false, allow_download_mirror: false });
                        }} control={<Radio checked={this.state.exibicao == 'folha_respostas'} value={'folha_respostas'} />} style={{ color: 'black' }} label={this.context.t("form_finished_result_answer_sheet")} />
                                                <FormControlLabel disabled={this.state.type == 'dissertativa'} onClick={(e) => {
                          console.log(e.target.value);
                          if (this.state.type == 'dissertativa') {
                            return;
                          }
                          this.setState({ exibicao: 'relacao_acerto_erros', mirror: false, allow_download_mirror: false });

                        }} control={<Radio checked={this.state.exibicao == 'relacao_acerto_erros' && this.state.mirror == false} value={'relacao_acerto_erros'} />} style={{ color: 'black' }} label={this.context.t("form_finished_result_accuracy_sheet")} />
                                                <FormControlLabel disabled={this.state.type == 'dissertativa'} onClick={(e) => {
                          console.log(e.target.value);
                          if (this.state.type == 'dissertativa') {
                            return;
                          }
                          this.setState({ exibicao: 'folha_relacao', mirror: false, allow_download_mirror: false });

                        }} control={<Radio checked={this.state.exibicao == 'folha_relacao'} value={'folha_relacao'} />} style={{ color: 'black' }} label={this.context.t("form_finished_result_answer_and_accuracy")} />

                                                <FormControlLabel disabled={this.state.type == 'dissertativa'} onClick={(e) => {
                          console.log(e.target.value);
                          if (this.state.type == 'dissertativa') {
                            return;
                          }
                          this.setState({ exibicao: 'none', mirror: true, allow_download_answer_sheet: false, allow_download_accuracy_sheet: false });

                        }} control={<Radio checked={this.state.mirror == true && this.state.exibicao != 'relacao_acerto_erros'} value={'mirror_correct'} />} style={{ color: 'black' }} label={this.context.t("form_finished_result_exam_booklet_correct")} />

                                                <FormControlLabel disabled={this.state.type == 'dissertativa'} onClick={(e) => {
                          console.log(e.target.value);
                          if (this.state.type == 'dissertativa') {
                            return;
                          }
                          this.setState({ exibicao: 'relacao_acerto_erros', mirror: true, allow_download_answer_sheet: false, allow_download_accuracy_sheet: false });

                        }} control={<Radio checked={this.state.mirror == true && this.state.exibicao == 'relacao_acerto_erros'} value={'mirror_candidate'} />} style={{ color: 'black' }} label={this.context.t("form_finished_result_exam_booklet_candidate")} />

                                                <FormControlLabel disabled={this.state.type == 'dissertativa'} onClick={(e) => {
                          console.log(e.target.value);
                          if (this.state.type == 'dissertativa') {
                            return;
                          }
                          this.setState({ exibicao: 'none', mirror: false, allow_download_answer_sheet: false, allow_download_accuracy_sheet: false, allow_download_mirror: false });

                        }} control={<Radio checked={this.state.exibicao == 'none' && this.state.mirror == false} value={'none'} />} style={{ color: 'black' }} label={this.context.t("form_finished_result_none")} />
                                            </RadioGroup>

                                        </div>
                                    </InputGroup>}

                                    {this.props.user?.empresa?.online_proccess == true && this.state.processo.online == true && this.state.type != 'dissertativa' && <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom me-3">
                                            <Form.Label>{this.context.t("form_finished_result_period")}</Form.Label>
                                            <small>{this.context.t("description_finished_result_period")}</small>
                                            <Input className="mb-2" type="datetime-local" value={this.state.show_result_start_at} onChange={(e) => this.setState({ show_result_start_at: e.target.value })} />
                                            <Input type="datetime-local" value={this.state.show_result_end_at} onChange={(e) => this.setState({ show_result_end_at: e.target.value })} />
                                        </div>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("form_finished_result_downloads")}</Form.Label>
                                            {this.state.exibicao == 'folha_respostas' && <FormCheck type="checkbox" checked={this.state.allow_download_answer_sheet == true} onChange={(e) => this.setState({ allow_download_answer_sheet: e.target.checked })} label={this.context.t("form_allow_download_answer_sheet")} />}
                                            {this.state.exibicao == 'folha_relacao' && <FormCheck type="checkbox" checked={this.state.allow_download_answer_sheet == true} onChange={(e) => this.setState({ allow_download_answer_sheet: e.target.checked, allow_download_accuracy_sheet: e.target.checked })} label={this.context.t("form_allow_download_answer_and_accuracy_sheet")} />}
                                            {this.state.exibicao == 'relacao_acerto_erros' && this.state.mirror == false && <FormCheck type="checkbox" checked={this.state.allow_download_accuracy_sheet == true} onChange={(e) => this.setState({ allow_download_accuracy_sheet: e.target.checked })} label={this.context.t("form_allow_download_accuracy_sheet")} />}
                                            {this.state.mirror == true && <FormCheck type="checkbox" checked={this.state.allow_download_mirror == true} onChange={(e) => this.setState({ allow_download_mirror: e.target.checked })} label={this.context.t("form_allow_download_mirror")} />}
                                        </div>
                                    </InputGroup>}

                                    {this.state.processo.exam_per_time == true && <>
                                        <Form.Label className='mt-1'>{this.context.t("ui_tempo_por_questao_em_minutos_5407240a")}<Attention /> </Form.Label>
                                        <Input
                      onWheel={(e) => e.target.blur()}
                      placeholder={this.context.t("ui_tempo_por_questao_eaffb704")}
                      value={this.state.time_per_question}
                      type="number"
                      onChange={(e) => this.setState({ time_per_question: e.target.value })}
                      required
                      min={1}
                      // title="Coloque o nome completo do usuário"
                    />
                                        <p style={{ marginTop: 10 }}><b>Tempo da prova em minutos: </b>{this.state.time_per_question * Object.values(this.state.questoes_selecionadas).map((item, id) => {
                        if (item.type_questao == 'conjunto') {
                          return item.questoes.length;
                        } else
                        {
                          return 1;
                        }
                      }).reduce((a, b) => a + b, 0) ?? '-'} minutos</p>
                                    </>}

                                    <hr />

                                    <h5 style={{ fontWeight: 'bold' }}>{this.context.t("questions")}</h5>
                                    <div style={{ marginTop: 8, marginBottom: 16 }}>
                                      <DefaultButton
                                        type="button"
                                        bg="confirm"
                                        icon={<MdUploadFile />}
                                        text={this.context.t("action_add_questions_docx")}
                                        onClick={() => this.setState({ showModalQuestoesDocx: true })} />
                                    </div>
                                    <br />
                                    <InputGroup>

                                    <div className={"flex fdcolumn flex1 " + (this.state.categoria.id == '' ? '' : 'margin-bottom')}>
                                    <Form.Label>{this.context.t("legacy_selecione_uma_disciplina")}</Form.Label>
                                            {/* <Input
                        placeholder="Nome da prova"
                        value={this.state.categoria}
                        onChange={(e) => this.setState({ categoria: e.target.value })}
                        required
                        // title="Coloque o nome completo do usuário"
                        /> */}
                                            <select disabled={this.state.loading_get_all} className="form-select margin-bottom" onChange={(e) => {
                        if (e.target.value != '') {
                          let categoria = this.state.categorias.filter((item, id) => item.id == e.target.value)[0];

                          this.setState({ categoria: categoria, questao_enunciado: '', questoes: [] });
                        } else
                        {
                          this.setState({ categoria: { id: '' }, questao_enunciado: '', questoes: [] });

                        }
                      }} value={this.state.categoria.id}>
                                                <option value="">{this.context.t("legacy_selecione_uma_disciplina")}</option>
                                                {this.state.categorias && this.state.categorias.length != 0 && this.state.categorias.map((value, index) =>
                        <option
                          key={index}
                          value={value["id"]}>
                          {value["nameKey"] ? this.context.t(value["nameKey"]) : value["name"]}</option>
                        )}
                                            </select>
                                            <div className="flex flex-wrap">
                                                <strong>Status:&nbsp;&nbsp;&nbsp;</strong>
                                                {["all", "aprovado", "pendente", "recusado"].map((option) =>
                        <div
                          key={option}
                          className="form-check align-items-center mb-2 me-4">

                                                        <input
                            type="radio"
                            name={"dsada" + option}
                            id={"dsada" + option}
                            className="form-check-input me-2"
                            value={option}
                            checked={this.state.statusFilter === option}
                            onChange={(e) => this.setState({ statusFilter: e.target.value }, () => {
                            })} />

                                                        <label htmlFor={option} className="form-check-label">
                                                            {option === "pendente" ? "Pendentes" : option === "aprovado" ? "Aprovadas" : option == 'recusado' ? "Desaprovadas" : "Todas"}
                                                        </label>
                                                    </div>
                        )}
                                            </div>
                                            {this.state.categoria.id != '' && <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <a onClick={() => {
                          this.get_questoes_categoria(this.state.categoria.id);

                        }} style={{ textAlign: 'left', fontSize: 15, marginTop: 10, marginRight: 20, cursor: 'pointer', textDecoration: 'none' }} className="link-success">{this.context.t("ui_selecionar_todas_as_questoes_desta_disciplina_7d72b315")}</a>

                                                <a onClick={() => {

                          this.setState({ showModalPalavraChave: true });
                        }} style={{ textAlign: 'left', fontSize: 15, marginTop: 10, cursor: 'pointer', textDecoration: 'none' }} className="link-success">{this.context.t("ui_selecionar_questoes_por_palavra_chave_76d0ed50")}</a>

                                            </div>}

                                        </div>

                                    </InputGroup>


                                    {this.state.categoria.id != '' && <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("legacy_busque_questoes_da_disciplina")} `}{this.state.categoria.name} </Form.Label>
                                            <Input
                        disabled={this.state.loading_get_all}
                        placeholder={this.context.t("legacy_pesquise_a_questao_pelo_enunciado")}
                        value={this.state.questao_enunciado}
                        // onChange={(e) => this.setState({ questao_enunciado: e.target.value })}
                        onBlur={() => {
                          this.timeout_ = setTimeout(() => {
                            this.setState({ show_autocomplete_questao: false });

                          }, 500);
                        }}
                        onFocus={() => {
                          clearTimeout(this.timeout_);
                          // console.log(Object.values(this.state.questoes_selecionadas).sort((a, b) => {
                          //     if (a.created_at > b.created_at) {
                          //         return 1;
                          //     }
                          //     if (a.created_at < b.created_at) {
                          //         return -1;
                          //     }
                          //     // a must be equal to b
                          //     return 0;
                          // }).sort((a, b) => {
                          //     if (a.categoria.created_at > b.categoria.created_at) {
                          //         return 1;
                          //     }
                          //     if (a.categoria.created_at < b.categoria.created_at) {
                          //         return -1;
                          //     }
                          //     // a must be equal to b
                          //     return 0;
                          // }))
                          this.setState({ show_autocomplete_questao: true });
                        }}
                        onChange={(e) => {this.get_questao_search(e.target.value, this.state.categoria.id);this.setState({ questao_enunciado: e.target.value });}}
                        // title="Coloque o nome completo do usuário"
                      />
                                            {this.state.show_autocomplete_questao == true && this.state.questao_enunciado != '' && <div className="overflow-auto" style={{ width: '100%', position: 'absolute', zIndex: 20, backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', maxHeight: '50vh', top: 70 }}>
                                                {this.state.loading_search_questao == false && this.state.questoes.map((item, id) =>
                        <div key={id} onClick={() => this.select_questao(item)} className="opcao_autocomplete">
                                                        <b>{item.categoria.name} - {item.type_questao == 'conjunto' ? 'Conjunto de questões: ' + item.questoes.length + (item.questoes.length == 1 ? ' questão' : ' questões') :
                            item.type_questao == 'simples' ? this.context.t("legacy_questao_unica") : 'Questão dissertativa'}</b> - {item.text_questao.length < 200 ? item.text_questao : item.text_questao.substring(0, 200) + '...'}
                                                    </div>
                        )}
                                                {this.state.loading_search_questao == false && this.state.questoes.length == 0 &&
                        <div className="opcao_autocomplete">{this.context.t("ui_nenhuma_questao_encontrada_com_este_termo_69f1b489")}

                        </div>
                        }
                                                {this.state.loading_search_questao == true &&
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                                        <div className="spinner-border text-primary" role="status">
                                                        </div></div>}
                                            </div>}
                                        </div>
                                    </InputGroup>}




                                    <Form.Label>{this.context.t("legacy_questoes_selecionadas")}</Form.Label>
                                    <br />
                                    <Form.Label>Total: <span style={{ fontWeight: 'normal' }}>{Object.values(this.state.questoes_selecionadas).map((item, id) => {
                        if (item.type_questao == 'conjunto') {
                          return item.questoes.length;
                        } else
                        {
                          return 1;
                        }
                      }).reduce((a, b) => a + b, 0)} {Object.values(this.state.questoes_selecionadas).map((item, id) => {
                        if (item.type_questao == 'conjunto') {
                          return item.questoes.length;
                        } else
                        {
                          return 1;
                        }
                      }).reduce((a, b) => a + b, 0) == 1 ? 'questão' : 'questões'}</span></Form.Label>

                                    <InputGroup>
                                        <DragDropTable draggable={true} data={this.state.questoes_array}
                    showData={(index) => {
                      let questao_id = 'q_' + this.state.questoes_array[index].id;
                      console.log(questao_id);

                      console.log(this.state.questoes_selecionadas[questao_id]);
                      this.setState({ questaoSelect: { ...this.state.questoes_selecionadas[questao_id] }, showModal: true });

                    }}
                    deleteData={(index) => {
                      let questao_id = this.state.questoes_array[index].id;
                      console.log(questao_id);
                      let questoes_selecionadas = { ...this.state.questoes_selecionadas };
                      delete questoes_selecionadas['q_' + questao_id];
                      let questoes_array = this.state.questoes_array.filter((item, id) => item.id != questao_id);
                      this.setState({ questoes_selecionadas, questoes_array });
                    }}
                    setData={(update_) => {
                      this.setState({ questoes_array: update_ });
                    }} />

                                        {/* <div className="flex fdcolumn flex1 margin-bottom col-12">
                      <div className="table-modern-card">
                      <div className="table-modern-scroll mb-0">
                      <table id="table" className="table table-striped">
                      <thead>
                      <tr>
                      <th>N.º</th>
                      <th>Enunciado</th>
                      <th>Categoria</th>
                      <th>Tipo de questão</th>
                      <th data-priority="3">Ações</th>
                      </tr>
                      </thead>
                      <tbody>
                      {Object.values(this.state.questoes_selecionadas).map((item, id) => (
                      <tr key={id}>
                      <td style={{textAlign:'justify'}}>{id+1})</td>
                      <td ><p className='text_overflow'>{item.text_questao}</p></td>
                      <td >{item.categoria.name}</td>
                      <td ><p style={{whiteSpace:'pre'}}>{item.type_questao=='conjunto'?('Conjunto de questões\n' +item.questoes.length+ (item.questoes.length==1?' questão':' questões')):
                      (item.type_questao=='simples'?'Questão única':'Questão dissertativa')}</p></td>
                      <td style={{minWidth:90}}>
                      <div className="actions-group">
                      <span
                      onClick={() => {
                       this.setState({ questaoSelect: item, showModal: true });
                      }}
                      className="inline-flex align-center jcc bg-warning icon"
                      style={{ width: "2em", height: "2em", borderRadius: "7px",marginRight:5 }}
                      title="Gerenciar aula"
                      >
                      <BsFillEyeFill size={17} color="white" />
                      </span>
                      <span
                      onClick={(e) => {
                       let questoes_selecionadas = { ...this.state.questoes_selecionadas };
                       delete questoes_selecionadas[item.id];
                       this.setState({ questoes_selecionadas });
                      }}
                      className="inline-flex align-center jcc bg-danger icon"
                      style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                      title="Deletar texto"
                      >
                      <MdDelete size={17} color="white" />
                      </span>

                      </div>
                      </td>
                      </tr>
                      ))}
                      </tbody>
                      </table>
                      </div>
                      </div>
                      {Object.values(this.state.questoes_selecionadas).length == 0 && <div className="row">
                      <div className="col-12">
                      <TableEmptyState title={this.context.t("legacy_nenhuma_questao_adicionada")} icon="❓" />
                      </div>
                      </div>}
                      </div> */




                    }

                                    </InputGroup>


                                    {this.state.loading_save == false && <div className="w100 inline-flex jcsb margin-top-1">
                                        {/* <Link to={`/accounts/list`}>
                      <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                      </Link> */}
                                        <DefaultButton
                      bg="secondary"
                      text={this.context.t("back")}
                      icon={<RiArrowGoBackLine />}
                      search={'?tab=1'}
                      to={`/processos/show/${this.state.processo.id}`} />

                                        {/* <Button variant="success" type="submit" disabled={this.loading}>
                      {this.state.loading ? <Spinner /> : ""}
                      Registrar usuário
                      </Button> */}
                                        <DefaultButton
                      type="submit"
                      bg="confirm"
                      text={this.context.t("legacy_salvar_prova")}
                      disabled={this.state.loading_image == true}
                      loadingtext="Salvando prova"
                      loading={this.state.loading_save} />

                                    </div>}

                                    {this.state.loading_save == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center margin-top-1">
                                        <div className="spinner-border text-primary" role="status">
                                        </div>
                                    </div></div>}
                                </Form>

                            </div>}

                            {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                <div className="spinner-border text-primary" role="status">
                                </div>
                            </div></div>}


                        </div>

                    </div>
                </div>
            </div>);

  }


}
const mapsStateToProps = (state) => (
{
  token: state.AppReducer.token,
  user: state.AppReducer.user

});


export default connect(mapsStateToProps, { logout })(EditarProva);
